import BaseService from '@root/core/class/BaseService';

class buskService extends BaseService {
  public getMyInfo = () => {
    return this.get('/me');
  };
  public updateMyInfo = (data: any) => {
    return this.put('/me', data);
  };
}

export default new buskService('/api/v1/forwarding', true);
